import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'

import SignUp from 'components/user/UserSignUp'
import {
  OrderDestination,
  OrderFinish,
  OrderForYourself,
  OrderForOthers,
} from './components'
import { forWhomTypes } from '../../constants'

import css from './style.module.scss'

export default connect(
  state => ({
    authToken: state.user.authToken,
  })
)(MakeOrder)

function MakeOrder({
  authToken,
}) {
  const [state, setState] = useState({
    city: null,
    forWhom: forWhomTypes.YOURSELF,
    step: authToken ? 0 : -1
  })

  useEffect(() => {
    if (authToken) {
      setState({
        ...state,
        step: 0
      })
    } else {
      setState({
        ...state,
        step: -1
      })
    }
  }, [authToken])

  function onChangeCity(selectedCity) {
    setState({
      ...state,
      city: {
        id: selectedCity.value,
        name: selectedCity.label,
        has_delivery: selectedCity.has_delivery,
      }
    })
  }

  function onChangeForWhom(event) {
    setState({
      ...state,
      city: null,
      forWhom: event.currentTarget.value
    })
  }

  function onNextButtonClick() {
    setState({
      ...state,
      step: 1
    })
  }

  function onSubmitSuccessHandler() {
    setState({
      ...state,
      step: 2
    })
  }

  function onClickPreviousButton(e) {
    e.preventDefault()

    setState({
      ...state,
      city: null,
      forWhom: forWhomTypes.YOURSELF,
      step: 0,
    })
  }

  return (
    <div className={css.userMakeOrder}>
      {(state.step !== 2) &&
        <div className={css.title}>
          <h1>Оформить заявку</h1>
        </div>
      }

      <div className={css.steps}>
        {
          ['Авторизация', 'Выбор города', 'Дополнительные данные'].map((item, idx) => (
            <div className={css.step} key={idx}>
              <p className={cn('caption', { 'blue': idx <= state.step + 1})}>{ idx + 1 } шаг</p>
              <p className={cn('caption', { 'blue': idx <= state.step + 1}, css.stepName)}>{ item }</p>
            </div>
          ))
        }
      </div>

      {
        (state.step === -1) &&
          <SignUp/>
      }

      {(state.step === 0) &&
        <div>
          <OrderDestination
            onChangeCity={onChangeCity}
            onChangeForWhom={onChangeForWhom}
            onNextButtonClick={onNextButtonClick}
            nextButtonDisabled={!state.city}
            forWhom={state.forWhom}
          />
        </div>
      }

      {(state.step === 1) &&
        <React.Fragment>
          {state.forWhom === forWhomTypes.YOURSELF &&
            <OrderForYourself
              city={state.city}
              onSubmitSuccess={onSubmitSuccessHandler}
              onClickPreviousButton={onClickPreviousButton}
            />
          }

          {state.forWhom === forWhomTypes.OTHERS &&
            <OrderForOthers
              city={state.city}
              onSubmitSuccess={onSubmitSuccessHandler}
              onClickPreviousButton={onClickPreviousButton}
            />
          }
        </React.Fragment>}

      {(state.step === 2) &&
        <OrderFinish />
      }
    </div>
  )
}
